// Options for the pipeline stage filter
export const PIPELINE_STAGE_OPTIONS = [
  { value: 'all', label: 'All Stages' },
  { value: 'screening_interview', label: 'Screening Interview' },
  { value: 'application_form', label: 'Application Form' },
  { value: 'drivers_license', label: "Driver's License" },
  { value: 'insurance_copy', label: 'Insurance Copy' },
  { value: 'reference_check', label: 'Reference Check' },
  { value: 'rna_license', label: 'RNA License' },
  { value: 'completed', label: 'Completed' },
  { value: 'rejected', label: 'Rejected' },
];

// Options for the ranking/sorting filter
export const RANK_BY_OPTIONS = [
  { value: 'date_applied', label: 'Date Applied' },
  // { value: 'time_in_stage', label: 'Time in Stage' },
];

// Options for the order filter
export const ORDER_OPTIONS = [
  { value: 'desc', label: 'Descending' },
  { value: 'asc', label: 'Ascending' },
];
